export type ChangeSessionReasonType = 'cancel' | 'reschedule';

export enum ChangeSessionReasonTypes {
  cancel = 'cancel',
  reschedule = 'reschedule',
}

export interface ChangeSessionReason {
  id: string;
  name?: string;
  description?: string;
  adminDescription?: string | null;
  type: ChangeSessionReasonType;
  descriptionPastTense?: string | null;
}

export interface ChangeSessionReasonTranslated extends ChangeSessionReason {
  translatedLabel: string;
}
